import { StyledDivider } from "./style";

const NavDivider = () => {
    return <StyledDivider />;
};

export default NavDivider;
